module.exports = __webpack_public_path__ + "img/Ardunic Elemnts round 2-05.df4ac1c7.svg";